import { render } from "./AnalisisPoliPacientes.vue?vue&type=template&id=8292533e"
import script from "./AnalisisPoliPacientes.vue?vue&type=script&lang=js"
export * from "./AnalisisPoliPacientes.vue?vue&type=script&lang=js"

import "./AnalisisPoliPacientes.vue?vue&type=style&index=0&id=8292533e&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__